import React from 'react';
import HeaderOne from '../../common/header/HeaderOne';
import BreadcrumbOne from '../../common/breadcrumb/BreadcrumbOne';
import AttorneySingleDetailsTwo from '../../components/attorney-components/AttorneySingleDetailsTwo';
import FooterOne from '../../common/footer/FooterOne';

const AttorneySingleTwo = () => {
    return (
        <>
        <HeaderOne />

        <BreadcrumbOne 
            title="Attorney Details 2"
            rootUrl="/"
            parentUrl="Home"
            currentUrl="Attorney Details 2"
        />
        
        <AttorneySingleDetailsTwo />
        
        <FooterOne />
        </>
    )
}
    
export default AttorneySingleTwo;